import React from 'react'
import { useConfig } from '@web/walter-lib/config'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'

import { lang } from './lang'
import styles from './style.module.css'
import { useCommonCMSConfig } from '~api'

const mockedNoServicesCountries = ['GB']

function NoServicesBanner() {
    const commonCMSConfig = useCommonCMSConfig()
    const config = useConfig()

    const showNoServicesBanner =
        commonCMSConfig.data?.features?.showNoServicesBanner &&
        (!config?.userMeta?.userCountry || mockedNoServicesCountries.includes(config?.userMeta?.userCountry))

    if (!showNoServicesBanner) {
        return null
    }

    return (
        <div data-pointer="no_services_countries_banner" className={styles.banner}>
            <FormattedHTMLMessage {...lang.banner} />
        </div>
    )
}

export default NoServicesBanner
